import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async reSendEmailManager({ commit }, measureId) {
      try {
        return await api.get(`/documents/re-send-email-manager/${measureId}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
